import * as actionTypes from "../actions/actionTypes";

const initialState = {
    classes: [],
    modules: [],
    totalCount: 0,
    isLoading: false,
    isSaving: false,
    isLocking: false,
    lockInfo: null,
    saveResponse: null,
    error: null,
};

const moduleRankingReducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.GET_CLASSES_REQUEST:
            return {
                ...state,
                error: null,
            };
        case actionTypes.GET_CLASSES_SUCCESS:
            return {
                ...state,
                classes: action.payload,
                error: null,
            };
        case actionTypes.GET_CLASSES_FAILURE:
            return {
                ...state,
                error: "Error fetching classes",
            };

        case actionTypes.GET_MODULE_RANKING_REQUEST:
            return {
                ...state,
                isLoading: true,
                error: null,
            };
        case actionTypes.GET_MODULE_RANKING_SUCCESS:
            return {
                ...state,
                isLoading: false,
                modules: action.payload.modules,
                totalCount: action.payload.totalCount,
                error: null,
            };
        case actionTypes.GET_MODULE_RANKING_FAILURE:
            return {
                ...state,
                isLoading: false,
                error: "Error fetching modules",
            };

        case actionTypes.SAVE_MODULE_RANKING_REQUEST:
            return {
                ...state,
                isSaving: true,
                saveResponse: null,
                error: null,
            };
        case actionTypes.SAVE_MODULE_RANKING_SUCCESS:
            return {
                ...state,
                isSaving: false,
                saveResponse: action.payload || null,
                error: null,
            };
        case actionTypes.SAVE_MODULE_RANKING_FAILURE:
            return {
                ...state,
                isSaving: false,
                saveResponse: null,
                error: "Error saving ranking",
            };
        case actionTypes.CLEAR_SAVE_MODULE_RANKING_RESPONSE:
            return {
                ...state,
                saveResponse: null,
            };

        case actionTypes.LOCK_MODULE_RANKING_REQUEST:
        case actionTypes.UNLOCK_MODULE_RANKING_REQUEST:
            return {
                ...state,
                isLocking: true,
                error: null,
            };
        case actionTypes.LOCK_MODULE_RANKING_SUCCESS:
        case actionTypes.UNLOCK_MODULE_RANKING_SUCCESS:
            return {
                ...state,
                isLocking: false,
                error: null,
            };
        case actionTypes.LOCK_MODULE_RANKING_FAILURE:
        case actionTypes.UNLOCK_MODULE_RANKING_FAILURE:
            return {
                ...state,
                isLocking: false,
                error: "Error locking ranking",
            };

        case actionTypes.GET_MODULE_RANKING_LOCK_REQUEST:
            return {
                ...state,
                lockInfo: null,
                error: null,
            };
        case actionTypes.GET_MODULE_RANKING_LOCK_SUCCESS:
            return {
                ...state,
                lockInfo: action.payload,
                error: null,
            };
        case actionTypes.GET_MODULE_RANKING_LOCK_FAILURE:
            return {
                ...state,
                lockInfo: null,
                error: "Error fetching lock status",
            };

        default:
            return state;
    }
};

export default moduleRankingReducer;
